import { createRouter, createWebHistory } from 'vue-router';
import { useAuthStore } from '@/stores/auth';

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: '/',
      component: () => import('@/layouts/MainLayout.vue'),
      children: [
        {
          path: '',
          name: 'home',
          component: () => import('@/views/Home.vue'),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: 'expenses',
          name: 'expenses',
          component: () => import('@/views/Expenses.vue'),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: 'calendar',
          name: 'calendar',
          component: () => import('@/views/Calendar.vue'),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: 'categories',
          name: 'categories',
          component: () => import('@/views/Categories.vue'),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: 'reports',
          name: 'reports',
          component: () => import('@/views/Reports.vue'),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: 'more',
          name: 'more',
          component: () => import('@/views/More.vue'),
          meta: {
            requiresAuth: true
          }
        }
      ]
    },
    {
      path: '/login',
      name: 'login',
      component: () => import('@/views/Login.vue'),
      meta: {
        requiresAuth: false
      }
    },
    {
      path: '/register',
      name: 'register',
      component: () => import('@/views/Register.vue'),
      meta: {
        requiresAuth: false
      }
    }
  ]
});

// 等待路由准备就绪
router.isReady().then(() => {
  router.beforeEach(async (to, from, next) => {
    const authStore = useAuthStore();
    const requiresAuth = to.matched.some((record) => record.meta.requiresAuth);

    // 等待认证检查完成
    const isAuthenticated = await authStore.isAuthenticated();

    if (requiresAuth && !isAuthenticated) {
      next('/login');
    } else if (!requiresAuth && isAuthenticated) {
      next('/');
    } else {
      next();
    }
  });
});

export default router; 